import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import api, { tControlFunction, tEffectiveness, EFFECTIVENESS } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { ShieldCheck, ChevronRight } from "lucide-react";

export function EffBadge({ eff }) {
  const rating = eff?.rating || "unknown";
  const cls = EFFECTIVENESS[rating]?.cls || EFFECTIVENESS.unknown.cls;
  const label = tEffectiveness(rating) + (eff?.is_expired ? " · expirée" : "");
  return <Badge variant="outline" className={`rounded-sm text-[10px] font-mono ${cls}`} title={eff?.creditable ? "Efficacité créditable (préparation Lot 4)" : "Non créditable"}>{label}</Badge>;
}

export default function ControlsPanel({ endpoint, queryKey }) {
  const navigate = useNavigate();
  const { data: controls = [] } = useQuery({
    queryKey,
    queryFn: async () => (await api.get(endpoint)).data,
  });
  return (
    <section className="border border-border bg-card rounded-sm" data-testid="section-controls">
      <div className="flex items-center justify-between px-6 py-4 border-b border-border">
        <h2 className="flex items-center gap-2 font-head font-semibold"><ShieldCheck className="h-4 w-4 text-primary" /> Contrôles — {controls.length}</h2>
      </div>
      <div className="p-6">
        <p className="text-xs text-muted-foreground mb-4">Contrôles associés (lecture seule) — gestion depuis la fiche Contrôle. <span className="text-foreground">La présence d'un contrôle ne réduit jamais automatiquement le risque.</span></p>
        {controls.length === 0 ? (
          <p className="text-sm text-muted-foreground">Aucun contrôle associé.</p>
        ) : (
          <div className="space-y-2">
            {controls.map((c) => (
              <button key={c.id} onClick={() => navigate(`/controls/${c.id}`)}
                className="w-full flex items-center justify-between gap-3 border border-border rounded-sm px-3 py-2 hover:border-primary/50 text-left"
                data-testid={`control-chip-${c.id}`}>
                <span className="flex items-center gap-2"><ShieldCheck className="h-3.5 w-3.5 text-muted-foreground" /> <span className="font-medium text-sm">{c.name}</span></span>
                <span className="flex items-center gap-2">
                  <Badge variant="outline" className="rounded-sm text-[10px] font-mono">{tControlFunction(c.function)}</Badge>
                  <EffBadge eff={c.effectiveness} />
                  <ChevronRight className="h-4 w-4 text-muted-foreground" />
                </span>
              </button>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
